var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"button"},[_c('i',{staticClass:"icon fab fah fa-lg far",class:{active: _vm.mutableLiked},attrs:{"aria-hidden":"true"},on:{"click":_vm.toggleLike}}),(_vm.showRequiredLoginModal)?_c('RequireLoginModal',{on:{"cancel":function($event){_vm.showRequiredLoginModal=false}}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }